<script>
    import { Router, Route, Link } from "svelte-routing";
    import Header from "../components/Header.svelte";
</script>

<!-- Content -->
<div class="page-container">
    <Header />
    <div class="about">
        <!-- About Text -->
        <div class="about-header">Innehåll</div>
        <br />
        <a
            href="#om-oss-section"
            class="index-text"
            style="text-decoration: none; color: inherit; margin-left: 0px;"
        >
            <span class="index-number">01</span>
            <span style="margin-left: 15px;">om oss</span>
        </a>
        <br />
        <a
            href="#service-section"
            class="index-text"
            style="text-decoration: none; color: inherit; margin-left: 0px;"
        >
            <span class="index-number">02</span>
            <span style="margin-left: 15px;">tjänsten</span>
        </a>
        <br />
        <a
            href="#malgrupp-section"
            class="index-text"
            style="text-decoration: none; color: inherit; margin-left: 0px;"
        >
            <span class="index-number">03</span>
            <span style="margin-left: 15px;">målgrupp</span>
        </a>
        <br />
        <a
            href="#nyheter-section"
            class="index-text"
            style="text-decoration: none; color: inherit; margin-left: 0px;"
        >
            <span class="index-number">04</span>
            <span style="margin-left: 15px;">nyheter</span>
        </a>
        <br />
        <a
            href="#kontakt-section"
            class="index-text"
            style="text-decoration: none; color: inherit; margin-left: 0px;"
        >
            <span class="index-number">05</span>
            <span style="margin-left: 15px;">kontakt</span>
        </a>
        <br />
        <div class="index-text" style="margin-left: 0px;">
            <Link to="legal" style="text-decoration: none; color: inherit;">
                <span class="index-number">06</span>
                <span style="margin-left: 15px;">allmänna villkor</span>
            </Link>
        </div>
    </div>

    <div id="om-oss-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Om Oss</span>
            <div class="divider"></div>
            <p>
                Boanalys grundades 2024 med en enkel men kraftfull övertygelse:
                att varje bostadsköpare förtjänar samma tillgång till
                information som proffs har. Sedan starten har vi legat i
                framkant när det gäller att automatiskt extrahera och tolka data
                ur komplexa fastighetsdokument.
            </p>
            <p>
                Vi följer utvecklingen inom AI och teknik på nära håll och
                applicerar ständigt de bästa tillgängliga verktygen på just den
                här branschen. Det betyder att tjänsten du använder idag är
                bättre än den som fanns igår, och att morgondagens version
                kommer vara bättre än den du ser nu. Vår ambition är att alltid
                ligga ett steg före, så att du kan fatta tryggare beslut.
            </p>
            <p>
                Vi tror att tillgång till pålitlig information är en rättighet,
                inte en lyx. Därför är grundläggande sökning och utforskning
                alltid gratis. Vill du gå djupare med detaljerade betyg, vår
                smarta chatbot BoBot, trendgrafer, stadgar och
                energideklarationer finns allt samlat i vårt abonnemang för
                49 kr/månad. Inga bindningstider, inga krångliga avtal.
            </p>
        </div>
    </div>

    <div id="service-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Så fungerar Boanalys</span>
            <div class="divider"></div>
            <p>
                Boanalys är inte bara ett verktyg. Det är en ny standard för
                brf-analys i Sverige. Vi omvandlar komplexa årsredovisningar,
                stadgar och energideklarationer till en kristallklar och
                interaktiv översikt. Genom att automatiskt analysera över 50
                unika datapunkter får du en djupare förståelse för allt från
                föreningens <strong>ekonomiska hälsa</strong>
                och underhållsbehov till dess dolda potential.
            </p>
            <p>
                För att garantera högsta möjliga datakvalitet använder vi en
                unik kombination av tekniker. En avancerad <strong
                    >OCR-motor</strong
                >
                extraherar informationen, som sedan tolkas av en
                <strong>stor språkmodell</strong>
                anpassad specifikt för svenska årsredovisningar, stadgar och energideklarationer.
                Det unika är vår valideringsprocess: vi nöjer oss inte med en källa,
                utan väver samman datan med andra pålitliga källor och använder
                <strong>matematiska kontroller</strong> för att säkerställa att alla
                siffror är korrekta och konsekventa.
            </p>
            <p>
                Denna robusta process ger dig ett kraftfullt och vägledande
                beslutsunderlag. Vi uppmanar dig dock alltid att se
                originaldokumentet som den slutgiltiga sanningen vid ett så
                viktigt beslut som en bostadsaffär.
            </p>
            <p>
                Tyvärr har vi sett att reviderade årsredovisningar kan innehålla
                felaktigt rapporterade siffror och i vissa fall är därmed våra
                siffror mer tillförlitliga än det som faktiskt står i
                originaldokumentet.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Hittar du inte din förening?</span
            >
            <p>
                Vår databas växer varje dag tack vare användare som du. Om din
                förening saknas beror det troligen på att vi ännu inte har fått
                in dess senaste årsredovisning. Du kan enkelt lösa detta genom
                att <strong>skapa ett konto och ladda upp den själv</strong>.
            </p>
            <p>
                Processen är enkel: kontrollera först att föreningen inte redan
                finns. Ladda sedan upp den senaste årsredovisningen i
                PDF-format. Du kan ladda upp hur många du vill, men vår analys
                fokuserar på det senaste året för att ge den mest relevanta
                bilden.
            </p>
            <p>
                Analysen tar bara några sekunder. När den är klar blir din
                förening en sökbar och permanent del av Boanalys, tillgänglig
                för dig och alla andra som behöver insikterna. Betygsättningen
                sker automatiskt och visas några sekunder efter analysen.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Den senaste årsredovisningen saknas?</span
            >
            <p>
                Eftersom databasen växer varje dag saknas det ibland föreningar
                som inte finns med ännu. Om det är så att du besitter en
                årsredovisning för ett år som inte finns med i vår databas kan
                du enkelt lösa detta genom att <strong
                    >skapa ett konto och ladda upp den själv</strong
                >.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Boanalys Plus – 49 kr/månad</span
            >
            <p>
                En bostadsaffär handlar om miljoner kronor. Med vårt abonnemang
                får du tillgång till alla verktyg och insikter som hjälper dig
                fatta rätt beslut – och undvika dyra misstag. Obegränsade
                analyser, detaljerade betyg, BoBot, trendgrafer, stadgar,
                energideklarationer och mycket mer. Inga bindningstider.
            </p>
            <p>Skapa ett konto och gå till din profil för att komma igång.</p>
        </div>
    </div>

    <div id="malgrupp-section" class="about-contact-container">
        <div>
            <span class="about-section-title"
                >Vi skapar värde för hela ekosystemet</span
            >
            <div class="divider"></div>
            <p>
                Problemet på bostadsmarknaden är fragmenterad data och brist på
                insikt. Vår mission är att lösa det. Genom att skapa en unik,
                strukturerad databas och en kraftfull AI-motor, levererar
                Boanalys värde till varje aktör – från den enskilda köparen till
                stora finansiella institut.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Bostadsköpare & Ägare</span
            >
            <p>
                Få en smidig överblick, djupa insikter och fatta bättre beslut.
                Vår tjänst är gratis och ger dig en pålitlig och lättförståelig
                360°-vy av en förenings ekonomi och hälsa. Gå från osäkerhet
                till trygghet inför ditt köp, eller få full koll på föreningen
                du redan bor i.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Styrelser</span
            >
            <p>
                Styr er förening med precision. Vårt verktyg hjälper er att
                förstå er egen data på djupet, jämföra er med andra och fatta
                strategiska beslut baserade på fakta. Kommunicera enkelt med
                medlemmar via BoBot och säkerställ att ni förvaltar föreningens
                ekonomi och framtid på bästa sätt.
            </p>

            <span class="about-section-title" style="font-size:1.2em;"
                >Professionella Aktörer</span
            >
            <p>
                Vi erbjuder ett kraftfullt ekosystem för B2B-partners som vill
                automatisera analyser, effektivisera processer och fatta
                datadrivna beslut.
            </p>

            <strong>Mäklare</strong>
            <p>
                Effektivisera er prospektanalys och erbjud en överlägsen,
                datadriven rådgivning. Vårt verktyg ger er ökad transparens
                gentemot kund och bygger förtroende genom att leverera djupa,
                verifierade insikter istället för ytliga nyckeltal.
            </p>

            <strong>Fastighetsförvaltare</strong>
            <p>
                Få ett oslagbart beslutsunderlag för ekonomi, underhåll och
                hållbarhetsinitiativ. Jämför era föreningars kostnader,
                identifiera besparingspotential och optimera driften med hjälp
                av vår djupdata, som kan integreras direkt i era system via API.
            </p>

            <strong>Banker & Finansiella Institut</strong>
            <p>
                Ta steget mot en modernare, datadriven kreditprocess. Vi
                erbjuder er möjligheten att licensiera vår plattform eller
                integrera vårt dataflöde via API för att automatisera och
                förädla era risk- och marknadsanalyser. Säkra er kreditkvalitet
                och minska er exponering med framtidens analysverktyg.
            </p>
        </div>
    </div>

    <div
        id="nyheter-section"
        class="about-contact-container"
        style="font-family: 'MuseoModerna';"
    >
        <div>
            <span class="about-section-title">Nyheter</span>
            <div class="divider"></div>
            <p>2025-11-18</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:activity:7396487756979449856"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 4"
            >
            </iframe>
            <p>2025-01-08</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7282665655219240960"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 3"
            >
            </iframe>
            <p>2024-12-10</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7272159189471248452"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 3"
            >
            </iframe>
            <p>2024-12-03</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7269453445277831171"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 2"
            >
            </iframe>
            <p>2024-10-01</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7248761225298276352"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 1"
            >
            </iframe>
        </div>
    </div>

    <div
        id="kontakt-section"
        class="about-contact-container"
        style="min-height: 400px;"
    >
        <div>
            <span class="about-section-title">Kontakt</span>
            <div class="divider"></div>
            <p>
                För frågor eller samarbeten (press, partnerskap och annat),
                vänligen kontakta oss på <a
                    href="mailto:info@boanalys.io"
                    style="color: var(--hover);">info@boanalys.io</a
                >.
            </p>
            <p>Du hittar oss annars här:</p>
            <ul>
                <li>
                    <i class="fab fa-linkedin"></i> LinkedIn:
                    <a
                        href="https://www.linkedin.com/company/boanalys/"
                        target="_blank"
                        style="color: var(--hover);"
                        >linkedin.com/company/boanalys</a
                    >
                </li>
                <li>
                    <i class="fab fa-patreon"></i> Patreon:
                    <a
                        href="https://www.patreon.com/c/Boanalys"
                        target="_blank"
                        style="color: var(--hover);">patreon.com/c/boanalys</a
                    >
                </li>
                <li>
                    <i class="fa-brands fa-twitter"></i> X:
                    <a
                        href="https://x.com/boanalys40361"
                        target="_blank"
                        style="color: var(--hover);">x.com/c/boanalys40361</a
                    >
                </li>
                <li>
                    <i class="fa-brands fa-facebook"></i> Facebook:
                    <a
                        href="https://www.facebook.com/people/Boanalys/61570346911684/"
                        target="_blank"
                        style="color: var(--hover);"
                        >facebook.com/people/boanalys/61570346911684/</a
                    >
                </li>
            </ul>
        </div>
    </div>
</div>

<style>
    .about {
        z-index: 4;
        color: black;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        border-radius: 15px; /* Rundade hörn */
        padding: 40px; /* Inre marginal */
        transition:
            transform 0.6s ease,
            box-shadow 0.6s ease;
        font-family: "MuseoModerna";
    }

    .about-header {
        font-size: 2em;
        margin-bottom: 20px;
        position: relative;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
    }

    .about-header::after {
        content: "";
        position: absolute;
        transform: translateX(-50%);
        bottom: -10px;
        left: 50%;
        width: 300px;
        height: 2px;
        background-color: #999; /* Linje mellan header och brödtext */
    }

    @keyframes rotateBlocks {
        0% {
            transform: rotate(0deg);
        }
        20% {
            transform: rotate(180deg);
        } /* Fast rotation: 180deg in 20% of time */
        50% {
            transform: rotate(225deg);
        } /* Slow rotation: 45deg in 30% of time */
        70% {
            transform: rotate(315deg);
        } /* Fast rotation: 90deg in 20% of time */
        100% {
            transform: rotate(360deg);
        } /* Slow rotation: 45deg in 30% of time */
    }

    .page-container {
        min-height: 100vh; /* Ensures the container covers the full viewport height */
        width: 100%;
        text-align: left;
    }

    .about-contact-container {
        z-index: 100;
        width: 800px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        padding-top: 50px;
    }

    .index-number {
        color: #999;
        font-size: 2em;
    }

    .index-text {
        margin-left: 15px;
    }

    .about-section-title {
        font-family: "MuseoModerna";
        font-size: 2em;
    }

    .divider {
        height: 2px; /* Thickness of the divider */
        background-color: #999; /* Color of the divider */
        margin: 15px auto; /* Spacing around the divider */
        border-radius: 5px; /* Optional: Adds rounded edges */
    }

    .linkedin-post {
        width: 100%;
        height: 400px; /* Adjust as needed */
        border: none; /* Remove default border */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a shadow */
        border-radius: 8px; /* Rounded corners */
        transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
    }

    .linkedin-post:hover {
        transform: translateY(-5px); /* Lift on hover */
        box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Deeper shadow on hover */
    }

    ul {
        list-style: none;
        padding: 10;
        margin: 0 auto;
    }

    .index-text {
        position: relative;
        text-decoration: none;
        color: inherit;
        display: inline-block;
        transition: color 0.3s ease;
    }

    /* Divider styles */
    .index-text::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -5px; /* Adjusts the position of the divider below the text */
        width: 0; /* Initial width of the divider */
        height: 2px; /* Thickness of the divider */
        background-color: var(--hover); /* Color of the divider */
        transition: width 0.3s ease; /* Smooth transition for the divider growth */
    }

    /* Hover effect */
    .index-text:hover::after {
        width: 100%; /* Grows to the full width of the text */
    }

    /* Optional: Change text color on hover */
    .index-text:hover {
        color: var(--hover);
    }

    @media (max-width: 840px) {
        .about {
            width: 70%;
        }

        .about-contact-container {
            padding-left: 20px;
            padding-right: 20px;
            width: 90% !important;
        }

        .about-header::after {
            width: 80%;
            left: 40%;
        }
    }
</style>
